import { render, staticRenderFns } from "./PhotoSlider.vue?vue&type=template&id=7f2b6aef&"
import script from "./PhotoSlider.vue?vue&type=script&lang=ts&"
export * from "./PhotoSlider.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports